import React from "react";
import { ADVISORY_BG } from "./data";
import { useRevealGroup } from "../../hooks/useReveal";
import { useViewRouter } from "../../hooks/useViewRouter";

const AdvisoryCTA = () => {
  const ref = useRevealGroup(".reveal");
  const { openContactModal } = useViewRouter();
  return (
    <section
      ref={ref}
      className="relative overflow-hidden py-28 lg:py-40"
      data-testid="advisory-cta"
    >
      <img
        src={ADVISORY_BG}
        alt="Grand estate library"
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(135deg, rgba(28,6,6,0.92), rgba(28,6,6,0.78))",
        }}
      />
      <div className="relative max-w-[760px] mx-auto px-6 lg:px-12 text-center">
        <div className="reveal flex items-center justify-center gap-3 mb-6">
          <span className="block w-10 h-px bg-num-gold" />
          <span className="font-ui text-[9px] uppercase text-num-gold track-eyebrow">
            Numbardar Wealth Advisory
          </span>
          <span className="block w-10 h-px bg-num-gold" />
        </div>
        <h2
          className="reveal delay-1 font-display font-medium text-num-cream leading-[1.05]"
          style={{ fontSize: "clamp(38px, 5.5vw, 64px)" }}
        >
          Let us manage <br />
          <span className="font-italic italic font-normal text-num-gold-light">
            your real estate wealth
          </span>
        </h2>
        <div
          className="reveal delay-2 mt-8 space-y-5 font-body italic text-[15px] leading-[1.85] max-w-[640px] mx-auto"
          style={{ color: "rgba(247,243,236,0.72)" }}
        >
          <p>
            We work with investors, families and institutions across all ticket sizes and asset
            classes. Our advisors carry deep relationships with India's finest builders and a
            network of verified real estate professionals spanning every major market.
          </p>
          <p>
            Whether you are buying your first investment property or managing a ₹200 Crore
            portfolio — your wealth deserves Numbardar-level custodianship.
          </p>
        </div>

        <div className="reveal delay-3 mt-12 flex justify-center">
          <button
            type="button"
            onClick={openContactModal}
            className="btn-gold px-9 py-4 font-ui text-[10px] uppercase"
            style={{ letterSpacing: "0.36em" }}
            data-testid="advisory-call-cta"
          >
            Schedule a Free Advisory Call
          </button>
        </div>
      </div>
    </section>
  );
};

export default AdvisoryCTA;
